import { createClient } from '@bastion/auth';

export function getSupabaseClient() {
  return createClient();
}

export async function getSupabaseAccessToken(): Promise<string> {
  const supabase = getSupabaseClient();
  const {
    data: { session },
    error,
  } = await supabase.auth.getSession();

  if (error) {
    throw new Error(`[Supabase] Failed to get session: ${error.message}`);
  }
  if (!session?.access_token) {
    throw new Error('[Supabase] Not signed in');
  }
  return session.access_token;
}

